import { render, staticRenderFns } from "./MaintainanceAmount.vue?vue&type=template&id=63777e64&"
import script from "./MaintainanceAmount.vue?vue&type=script&lang=js&"
export * from "./MaintainanceAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports